import { useEffect, useState } from "react";
// @mui
import {
	Button,
	Grid,
	TextField,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@mui/material";

// ----------------------------------------------------------------------

const defaultState = {
	pageKey: ""
};
export default function PageDialog(props) {
	const [page, setPage] = useState(defaultState);

	useEffect(() => {
		if (props.page !== null) {
			setPage(props.page);
		}
	}, [props]);
	const handleChange = (e) => {
		const { id, value } = e.target;

		setPage((prevState) => ({
			...prevState,
			[id]: value,
		}));
	};

	const onSuccess = () => {
		setPage(defaultState);
		props.onSuccessHandler(page);
	};
	const onCancel = () => {
		setPage(defaultState);
		props.onClose();
	};
	return (
		<>
			<Dialog
					open={props.open}
					onClose={() => {}}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						{props?.page?'Edit Page':'Create Page'}
					</DialogTitle>
					<DialogContent>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<TextField
									id="pageKey"
									label="Page Key"
									fullWidth
									value={page.pageKey}
									variant="standard"
									onChange={handleChange}
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button onClick={() => onCancel()}>Cancel</Button>
						<Button
							onClick={() => onSuccess()}
							autoFocus
							disabled={!page.pageKey}
						>
							{props?.page ? "Edit":"Create"}
						</Button>
					</DialogActions>
				</Dialog>
		</>
	);
}
